import FAHome from './FAHome'
import FACalendar from './FACalendar'
import FAUser from './FAUser'
import FAFile from './FAFile'
import FACheckSquare from './FACheckSquare'
import FASpinner from './FASpinner'
import FAPaw from './FAPaw'
import FAChevronLeft from './FAChevronLeft'
import FAChevronRight from './FAChevronRight'
import FAChevronDown from './FAChevronDown'
import FAChevronUp from './FAChevronUp'
import FAUserCircleO from './FAUserCircleO'
import FAClock from './FAClock'
import FADotCircle from './FADotCircle'
import FACheckCircle from './FACheckCircle'
import FAUpload from './FAUpload'

export {
    FAHome,
    FACalendar,
    FAUser,
    FAFile,
    FACheckSquare,
    FASpinner,
    FAPaw,
    FAChevronLeft,
    FAChevronRight,
    FAChevronDown,
    FAChevronUp,
    FAUserCircleO,
    FAClock,
    FADotCircle,
    FACheckCircle,
    FAUpload
}


// WEBPACK FOOTER //
// ./components/elements/FontAwesome/index.js